<template>
  <div class="main main-tabbar">
    <!-- 左栏分类 -->
    <div class="category-list">
      <div class="category-wrap" 
        v-for="c in categorys" 
        :key="'c0-'+c.cateId" 
        :class="{'selected' : currCategory && currCategory.cateId == c.cateId}" 
        v-if="c.tagGroups.length > 0 && c.tagGroups[0].tags.length > 0"
        @click="selectCategory(c)">
        <i class="icon icon-category-selected"></i>
        <span>{{c.name}}</span>
      </div>
    </div>
    <!-- 右栏标签组 -->
    <div class="taggroup-list"
      @scroll="onScroll"
      @touchend="onScroll"
    >
      <template v-for="c in categorys" v-if="c.tagGroups.length > 0 && c.tagGroups[0].tags.length > 0">
        <TagGroup :items="c.tagGroups" :key="'c1-'+c.cateId" :id="'category-'+c.cateId"/>
      </template>
    </div>

    <TabBar active="categorys"></TabBar>
  </div>
  
</template>

<script>
import $ from "jquery";
import api from '../../api'
import TagGroup from '@/components/products/TagGroup'

export default {
  title: '分类',
  components: {TagGroup},
  data () {
    return {
      currCategory: null,
      categorys: [
        // {cateId: 3, name: '手机数码', tagGroups: [
        //   {tagGroupId: 5,name: '礼品卡券', banner: 'http://res.uuudian.com/hk_data/c59a7144-69b4-473f-a65a-ea59b6f53b2a', tags: [
        //     {tagId: 9, img: 'http://res.uuudian.com/hk_data/828e3014-f5ee-4d0a-bbfe-c0bf815c1932', name: '京东E卡'},
        //     {tagId: 10, img: 'http://res.uuudian.com/hk_data/45271a5d-a8bb-440a-81d8-1d9c24a48a79', name: '京东礼品卡'},
        //     {tagId: 11, img: 'http://res.uuudian.com/hk_data/c64eb68c-516a-4464-a29c-72681f799b47', name: '京东优惠券'},
        //   ]}
        // ]},
      ]
    }
  },
  methods:{
    selectCategory(category){
      this.currCategory = category;
      //动画滚到相应位置
      var t_a = $("#category-" + category.cateId).offset();
      $(".taggroup-list").animate({scrollTop:($('.taggroup-list').scrollTop() -$('.taggroup-list').offset().top + t_a.top) + "px"}, 500);
    },
    onScroll(){
      var h = 0, elemInGap = [], prevElem = null;
      const Gap = 100;
      const ScrollTop = $('.taggroup-list').scrollTop();
      $('.category-item-wrap').each(function(){
        var self = $(this);
        
        if(h <= ScrollTop + Gap){
          
          prevElem = this;
        }
        //累计高度
        h += self.height();
      });

      if(prevElem){
        var self = $(prevElem);
        var id = self.attr('id').split('-')[1];
        this.categorys.forEach(c=>{
          if(c.cateId == id){
            this.currCategory = c;
          }
        })
      }
    }
  },
  created: function () {
    //初始化数据
    this.$showLoading('加载中...');
    api.product.getCategoryList((cateList)=>{
      console.log(cateList);
      cateList.list.forEach(c => {
        if(c.tagGroups.length > 0){
          var cate = {cateId: c.id, name: c.name, tagGroups: []};
          c.tagGroups.forEach(tg => {
            var tagGroup = {tagGroupId: tg.id, name: tg.title, banner: tg.image, tags: []};
            tg.tags.forEach(t=>{
              tagGroup.tags.push({tagId: t.id, img: t.imageIcon, name: t.title});
            });
            cate.tagGroups.push(tagGroup);
          });
          this.categorys.push(cate);
        }
        
      });
      this.currCategory = this.categorys[0];
      this.$hideLoading();
    }, r=>{
      this.$alertDialog(r.msg);
      this.$hideLoading();
    });
  }
}
</script>

<style lang="less" scoped>

.category-list{
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  bottom: 0;
  width: 28vw;
  overflow-y: auto;
  background: #f6f5fb;
  padding-bottom: 14vw;
  
  .category-wrap{
    line-height: 12vw;
    text-align: center;
    position: relative;
    z-index: 2;
    font-size:3.6vw;
    overflow: hidden;

    .icon-category-selected{
      background-image: url(../../assets/icon-category-selected.png);
      position: absolute;
      z-index: 3;
      left: -.5vw;
      top: -1vw;
      height: 14vw;
      opacity: 0;
    }

    &.selected{
      color: @themeColor;
      background: #fff;
      .icon-category-selected{
        opacity: 1;
      }
    }
  }

}

.taggroup-list{
  margin-left: 28vw;
  height: 100vh;
  overflow-y: auto;
  -webkit-overflow-scrolling : touch;
}
</style>



// WEBPACK FOOTER //
// src/pages/products/Categorys.vue